function Home() {
    return (
        <section>
            <h1> Home</h1>
        </section>
    );
}

export default Home;
